export const buildFontSize = (size: avatar.ThumbnailSize) => {
    switch (size) {
        case 'Smallest':
            return '8px';
        case 'Small':
            return '10px';
        case 'Normal':
            return '12px';
        case 'Large':
            return '20px';
        case 'Largest':
            return '20px';
    }
};

export const buildSize = (size: avatar.ThumbnailSize) => {
    switch (size) {
        case 'Smallest':
            return 32;
        case 'Small':
            return 40;
        case 'Normal':
            return 48;
        case 'Large':
            return 80;
        case 'Largest':
            return 96;
    }
};

export const buildShape = (shape: avatar.ThumbnailShape) => {
    if (shape === 'Circular') {
        return '50%';
    } else {
        return '4px';
    }
};
